// src/ui/icons/icons.jsx
import { Icon as IconifyIcon } from "@iconify/react";

export default function Icon({
  icon,
  size = "1em",
  color = "currentColor",
  className = "",
  style = {},
  ...props
}) {
  if (!icon) return null;

  // Handle URL SVG
  if (typeof icon === "string" && icon.startsWith("url:")) {
    const url = icon.replace("url:", "");
    return (
      <img
        src={url}
        alt="icon"
        className={`inline-block ${className}`}
        style={{
          width: size,
          height: size,
          color,
          ...style,
        }}
        {...props}
      />
    );
  }

  // Handle Iconify icons
  return (
    <IconifyIcon
      icon={icon}
      width={size}
      height={size}
      className={`inline-block ${className}`}
      style={{
        color,
        height: size,
        width: size,
        ...style,
      }}
      {...props}
    />
  );
}
